import { Box, Grid } from '@material-ui/core';
import { observer } from 'mobx-react';
import { BorrowerFormCard } from '../common/borrowerFormCard';
import { EntityInformationSummaryCard } from './entityInformationSummaryCard';
import { Button } from '@roc/ui';
import { Add } from '@material-ui/icons';
import { IQuoteTypeStore } from '../../stores/common/iQuoteTypeStore';

interface BorrowerInformationStepProps {
  store: IQuoteTypeStore;
}

export const BorrowerInformationStep = observer(
  ({ store }: BorrowerInformationStepProps) => {
    const { borrowersStore, entityStore } = store;
    const { entityFormStore } = entityStore;
    const { borrowerFormStores } = borrowersStore;
    const { hasEntity } = entityFormStore.form.fields;

    return (
      <>
        <Grid container spacing={2} alignItems="center">
          {!!hasEntity.value && (
            <Grid item xs={12}>
              <EntityInformationSummaryCard />
            </Grid>
          )}
          {borrowerFormStores.map(borrowerFormStore => (
            <Grid item xs={12}>
              <BorrowerFormCard borrowerFormStore={borrowerFormStore} />
            </Grid>
          ))}
          <Grid item xs={12}>
            <Box display="flex" justifyContent="center">
              <Button
                size="medium"
                variant="outlined"
                color="primary"
                startIcon={<Add />}
                testId="edit-borrower"
                onClick={() => borrowersStore.addNewBorrower()}
              >
                ADD MORE BORROWERS
              </Button>
            </Box>
          </Grid>
        </Grid>
      </>
    );
  }
);
